import { Link } from "react-router-dom";
import { FileText, ArrowUpRight } from "lucide-react";
import { gbp } from "@/lib/api";

export const ReportCard = ({ r, dark = false, index = 0 }) => (
  <Link to={`/research/${r.slug}`} data-testid={`report-card-${r.slug}`} style={{ animationDelay: `${index * 80}ms` }}
    className={`group block fade-up border ${dark ? "border-white/10 bg-white/[0.03] hover:bg-white/[0.07]" : "border-[#E7E7E7] bg-white hover:border-[#E5332A]"} transition-colors`}>
    <div className="img-zoom overflow-hidden aspect-[16/9]"><img src={r.image} alt={r.title} className="w-full h-full object-cover" loading="lazy" /></div>
    <div className="p-6">
      <div className={`flex items-center justify-between overline ${dark ? "text-[#E5332A]" : "text-[#E5332A]"}`}>
        <span className="flex items-center gap-1"><FileText size={12} /> {r.kind === "monthly" ? "Monthly Report" : r.category}</span>
        <span>{r.pages} pp</span>
      </div>
      <h3 className={`font-display text-xl font-semibold mt-3 leading-snug ${dark ? "text-white" : ""}`}>{r.title}</h3>
      <p className={`text-sm mt-3 leading-relaxed line-clamp-3 ${dark ? "text-[#E7E7E7]/70" : "text-[#575757]"}`}>{r.summary}</p>
      <div className="mt-5 flex items-center justify-between">
        <span className={`font-mono-d text-sm ${dark ? "text-white" : ""}`} data-testid={`report-price-${r.slug}`}>{gbp(r.price)} <span className="text-xs opacity-60">· incl. {r.included_tiers?.includes("pro") ? "Pro" : "Institutional"}</span></span>
        <ArrowUpRight size={18} className={`${dark ? "text-[#E5332A]" : "text-[#E5332A]"} group-hover:translate-x-0.5 group-hover:-translate-y-0.5 transition-transform`} />
      </div>
    </div>
  </Link>
);
